module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-system-bar', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "height": "30",
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.step === 0,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.canNext
    },
    on: {
      "click": function($event) {
        _vm.step++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c(_vm.layoutComponent, {
    tag: "component",
    attrs: {
      "step": _vm.step
    },
    on: {
      "update:step": function($event) {
        _vm.step = $event
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-4",
    attrs: {
      "slot": "step-0",
      "flat": "",
      "dark": "",
      "tile": "",
      "height": "100%"
    },
    slot: "step-0"
  }, [_vm._t("ag-filters", function() {
    return [_c('appointment-filters', {
      staticClass: "mx-2",
      attrs: {
        "mini": "",
        "require-daterange": "",
        "title": "Find appointments",
        "with-icon": false,
        "with-theme-toggle": false,
        "compact": _vm.compact,
        "touch": _vm.filterTouch,
        "page-size": _vm.pageSize,
        "num-results": _vm.appointments.length,
        "practitioner-id": _vm.computedPractitionerId,
        "relationship": _vm.relationship,
        "initial-relationship": _vm.initialRelationship,
        "multiple-relationships": false,
        "relationship-statuses": _vm.statuses.split(',')
      },
      on: {
        "update:pageSize": function($event) {
          _vm.pageSize = $event
        },
        "update:page-size": function($event) {
          _vm.pageSize = $event
        },
        "update:relationship": _vm.setRelationship,
        "count": _vm.setCount
      },
      model: {
        value: (_vm.filters),
        callback: function($$v) {
          _vm.filters = $$v
        },
        expression: "filters"
      }
    }, [(_vm.componentName === "CreateInvoice") ? _c('template', {
      slot: "actions"
    }, [(_vm.infoIsTeamAccount) ? _c('v-switch', {
      staticClass: "mb-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Only my appointments"
      },
      model: {
        value: (_vm.withPersonalFilter),
        callback: function($$v) {
          _vm.withPersonalFilter = $$v
        },
        expression: "withPersonalFilter"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Include paid appointments"
      },
      model: {
        value: (_vm.withPaid),
        callback: function($$v) {
          _vm.withPaid = $$v
        },
        expression: "withPaid"
      }
    }), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Include previously invoiced appointments"
      },
      model: {
        value: (_vm.withInvoiced),
        callback: function($$v) {
          _vm.withInvoiced = $$v
        },
        expression: "withInvoiced"
      }
    }), _vm._v(" "), _c('v-switch', {
      staticClass: "my-0 mx-4",
      attrs: {
        "dense": "",
        "label": "Oldest first"
      },
      model: {
        value: (_vm.oldestFirst),
        callback: function($$v) {
          _vm.oldestFirst = $$v
        },
        expression: "oldestFirst"
      }
    })], 1) : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('template', {
    slot: "step-1"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showinvoicedetails),
      callback: function($$v) {
        _vm.showinvoicedetails = $$v
      },
      expression: "showinvoicedetails"
    }
  }, [(_vm.selectedAppointment) ? _c('invoice-details', {
    attrs: {
      "with-create": false
    },
    on: {
      "finalprice": function($event) {
        _vm.dirty = true
      },
      "close": function($event) {
        _vm.showinvoicedetails = false
      }
    },
    model: {
      value: (_vm.selectedAppointment),
      callback: function($$v) {
        _vm.selectedAppointment = $$v
      },
      expression: "selectedAppointment"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.appointmentsLoading) ? _c('tombstone') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.appointmentsLoading === false),
      expression: "appointmentsLoading===false"
    }]
  }, [(_vm.relationship && _vm.relationship.id) ? _c('appointment-list', {
    attrs: {
      "dense": "",
      "with-select-all": "",
      "selected": _vm.appointments,
      "title": "Choose appointments",
      "cards": _vm.cardView,
      "with-price": false,
      "page-size": _vm.pageSize,
      "loading": _vm.appointmentsLoading,
      "relationship": _vm.relationship,
      "relationship-statuses": _vm.statuses,
      "with-action": false,
      "with-actions": false,
      "multiple": true,
      "params": _vm.params,
      "touch": _vm.listTouch
    },
    on: {
      "update:selected": function($event) {
        _vm.appointments = $event
      },
      "update:cards": function($event) {
        _vm.cardView = $event
      },
      "update:loading": function($event) {
        _vm.appointmentsLoading = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "listaction",
      fn: function(appt) {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedAppointment = appt.appointment;
              _vm.showinvoicedetails = true
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1)]
      }
    }], null, false, 2019933857)
  }, [(_vm.filters && _vm.filters.after_utc) ? _c('template', {
    slot: "top"
  }, [_c('v-system-bar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-icon', {
    staticClass: "mr-2 pl-3",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")])], 1), _vm._v("\n              " + _vm._s(_vm.filters.after_utc) + " - " + _vm._s(_vm.filters.before_utc) + "\n            ")], 1)], 1) : _vm._e()], 2) : _c('v-card', {
    staticClass: "ma-3 blue lighten-5"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', [_vm._v("arrow_left")]), _vm._v("\n            " + _vm._s(_vm.activeComponent.step1Instructions.title) + "\n          ")], 1), _vm._v(" "), _c('v-card-text', [_c('ul', _vm._l((_vm.activeComponent.step1Instructions.bullets), function(li) {
    return _c('li', {
      key: li,
      domProps: {
        "textContent": _vm._s(li)
      }
    })
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.canNext,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.step++
      }
    }
  }, [_vm._v("next")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "step-2"
  }, [(_vm.relationship && _vm.relationship.id && _vm.appointments && _vm.appointments.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [
    [(_vm.activeComponent && _vm.activeComponent.title) ? _c('v-card-title', {
      staticClass: "overline grey lighten-4 py-2"
    }, [(_vm.activeComponent.icon) ? _c('v-icon', {
      staticClass: "mr-2 small"
    }, [_vm._v(_vm._s(_vm.activeComponent.icon))]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.activeComponent.title) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": _vm.reset
      }
    }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeComponent && _vm.activeComponent.title) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c(_vm.activeComponent.component, _vm._b({
      tag: "component",
      attrs: {
        "relationship": _vm.relationship,
        "appointments": _vm.appointments
      },
      on: {
        "close": function($event) {
          _vm.listTouch++;
          _vm.appointments = [];
          _vm.step = 0;
          _vm.$emit("close")
        },
        "done": function($event) {
          _vm.listTouch++;
          _vm.appointments = [];
          _vm.step = 0;
          _vm.$emit("close")
        },
        "next": function($event) {
          _vm.appointments = [];
          _vm.listTouch++;
          _vm.filterTouch++;
          _vm.step = 0;
        },
        "success": function($event) {
          return _vm.$emit("success")
        }
      }
    }, 'component', _vm.activeComponent.attrs, false))]
  ], 2) : _c('v-card', {
    staticClass: "ma-3 blue lighten-5"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', [_vm._v("arrow_left")]), _vm._v("\n          " + _vm._s(_vm.activeComponent.step2Instructions.title) + "\n        ")], 1), _vm._v(" "), _c('v-card-text', [_c('ul', _vm._l((_vm.activeComponent.step2Instructions.bullets), function(li) {
    return _c('li', {
      key: li,
      domProps: {
        "textContent": _vm._s(li)
      }
    })
  }), 0)])], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4593c7f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/AppointmentAction.vue
// module id = 1410
// module chunks = 9